module.exports = __webpack_public_path__ + "static/media/tabs-product.054deb4c.png";